import { window, process, isBrowser } from './globals';
export function getTimestamp() {
  if (!isBrowser) {
    var secondsAndNanoseconds = process.hrtime();
    return secondsAndNanoseconds[0] + secondsAndNanoseconds[1] / 1e6;
  }

  if (window.performance) {
    return window.performance.now();
  }

  return Date.now();
}
export var startTimestamp = getTimestamp();
//# sourceMappingURL=timestamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/esm/lib/utils/timestamp.js
// module id = 793
// module chunks = 0